import React from 'react';
import ClassroomCameras from './components/ClassroomCameras';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedGallery from './components/FeaturedGallery';
import About from './components/About';
import EnrollmentForm from './components/EnrollmentForm';
import EnrollmentManagement from './components/EnrollmentManagement';
import VisionMission from './components/VisionMission';
import Programme from './components/Programme';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Admin Pages
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import StudentRegistration from './components/StudentRegistration';
import ManageClasses from './components/ManageClasses';
import StudentManagement from './components/StudentManagement';
import ManageSubjectsTopicsLessons from './components/ManageSubjectsTopicsLessons';
import StudentLogin from './components/StudentLogin';
import StudentDashboard from './components/StudentDashboard';
import SchoolFees from './components/SchoolFees';
import StudentProfile from './components/StudentProfile';
import ForcePasswordChange from './components/ForcePasswordChange';
import ParentForcePasswordChange from './components/ParentForcePasswordChange';
import VideoRoom from './components/VideoRoom';
import ClassTracker from './components/ClassTracker';
import LearningHub from './components/LearningHub';
import LearnPage from './components/LearnPage';
import AdminFeeManagement from './components/AdminFeeManagement';
import AdminAttendanceManagement from './components/AdminAttendanceManagement';
import GeneralAttendanceDashboard from './components/GeneralAttendanceDashboard';
import AdminProgressManagement from './components/AdminProgressManagement';
import AdminAnalyticsDashboard from './components/AdminAnalyticsDashboard';
import AdminAnnouncements from './components/AdminAnnouncements';
import AdminFeedback from './components/AdminFeedback';
import AdminTimetableManagement from './components/AdminTimetableManagement';
import SchoolNews from './components/SchoolNews';
import StudentFeedback from './components/StudentFeedback';
import ManageMidtermExams from './components/ManageMidtermExams';
import ManageFinalExams from './components/ManageFinalExams';
import MidtermExamPage from './components/MidtermExamPage';
import FinalExamPage from './components/FinalExamPage';
import ProgressBoard from './components/ProgressBoard';
import TeacherManagement from './components/TeacherManagement';
import NonAcademicStaffManagement from './components/NonAcademicStaffManagement';
import StaffLogin from './components/StaffLogin';
import StaffDashboard from './components/StaffDashboard';
import StaffForcePasswordChange from './components/StaffForcePasswordChange';
import TeacherLogin from './components/TeacherLogin';
import TeacherDashboard from './components/TeacherDashboard';
import TeacherForcePasswordChange from './components/TeacherForcePasswordChange';
import SecurityManagement from './components/SecurityManagement';
import SecurityPage from './components/SecurityPage';
import SecurityLogin from './components/SecurityLogin';
import SecurityDashboard from './components/SecurityDashboard';
import UnifiedSalaryManagement from './components/UnifiedSalaryManagement';
import ExpenseDashboard from './components/ExpenseDashboard';
import ExpenseRequestDashboard from './components/ExpenseRequestDashboard';
import ExpenseRequestForm from './components/ExpenseRequestForm';
import AdminGalleryManagement from './components/AdminGalleryManagement';
import ApprovalManagement from './components/ApprovalManagement';
import KidstoonPage from './components/KidstoonPage';
import Games from './components/Games';
import RealtimeDashboardOverview from './components/RealtimeDashboardOverview';
import AdminMessaging from './components/AdminMessaging';
import AdPage from './components/AdPage';
import AdminAdManagement from './components/AdminAdManagement';
import AdminEmailManagement from './components/AdminEmailManagement';
import AdminTrackingDashboard from './components/AdminTrackingDashboard';
import ActivityTracker from './components/ActivityTracker';
import ParentLogin from './components/ParentLogin';
import ParentDashboard from './components/ParentDashboard';
import ParentManagement from './components/ParentManagement';
import AdminVideoCallSettings from './components/AdminVideoCallSettings';
import FeePaymentCallback from './components/FeePaymentCallback';

// Inner component to use useLocation hook
function AppContent() {
  const location = useLocation();
  const isAdPage = location.pathname === '/ad';
  const isSecurityPage = location.pathname === '/security';

  return (
    <div className="font-sans text-gray-800 min-h-screen flex flex-col">
      <ActivityTracker />
      {/* Navbar - hidden on /ad page */}
      {!isAdPage && !isSecurityPage && <Navbar />}

      {/* Main Content */}
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={
            <div>
              <Hero />
              <FeaturedGallery />
            </div>
          } />
          <Route path="/about" element={<About />} />
          <Route path="/enrollment" element={<EnrollmentForm />} />
          <Route path="/vision" element={<VisionMission />} />
          <Route path="/programme" element={<Programme />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ad" element={<AdPage />} />

          {/* Admin Pages */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/fee-management" element={<AdminFeeManagement />} />
          <Route path="/admin/attendance-management" element={<AdminAttendanceManagement />} />
          <Route path="/admin/general-attendance-dashboard" element={<GeneralAttendanceDashboard />} />
          <Route path="/admin/progress-management" element={<AdminProgressManagement />} />
          <Route path="/admin/analytics" element={<AdminAnalyticsDashboard />} />
          <Route path="/admin/news" element={<AdminAnnouncements />} />
          <Route path="/admin/feedback" element={<AdminFeedback />} />
          <Route path="/admin/register-student" element={<StudentRegistration />} />
          <Route path="/admin/manage-classes" element={<ManageClasses />} />
          <Route path="/manage-students" element={<StudentManagement />} />
          <Route path="/admin/manage-students" element={<StudentManagement />} />
          <Route path="/admin/manage-subjects" element={<ManageSubjectsTopicsLessons />} />
          <Route path="/admin/timetable-management" element={<AdminTimetableManagement />} />
          <Route path="/student-login" element={<AdminLogin />} />
          <Route path="/parent-login" element={<AdminLogin />} />
          <Route path="/parent/change-password" element={<ParentForcePasswordChange />} />
          <Route path="/parent/dashboard" element={<ParentDashboard />} />
          <Route path="/parent/cameras" element={<ClassroomCameras />} />
          <Route path="/admin/cameras" element={<ClassroomCameras />} />
          <Route path="/parent/fee-payment-callback" element={<FeePaymentCallback />} />
          <Route path="/video-room/:roomId" element={<VideoRoom />} />
          <Route path="/admin/parents" element={<ParentManagement />} />
          <Route path="/admin/video-call-settings" element={<AdminVideoCallSettings />} />
          <Route path="/student/force-password-change" element={<ForcePasswordChange />} />
          <Route path="/student-dashboard" element={<StudentDashboard />} />
          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route path="/student/kidstoon" element={<KidstoonPage />} />
          <Route path="/student/games" element={<Games />} />
          <Route path="/student/fees" element={<SchoolFees />} />
          <Route path="/student/profile" element={<StudentProfile />} />
          <Route path="/student/learn" element={<LearnPage />} />
          <Route path="/student/class-tracker" element={<ClassTracker />} />
          <Route path="/student/learning-hub" element={<LearningHub />} />
          <Route path="/student/news" element={<SchoolNews />} />
          <Route path="/student/complain" element={<StudentFeedback />} />
          <Route path="/admin/midterm-exams" element={<ManageMidtermExams />} />
          <Route path="/admin/final-exams" element={<ManageFinalExams />} />
          <Route path="/admin/teacher-management" element={<TeacherManagement />} />
          <Route path="/admin/staff-management" element={<NonAcademicStaffManagement />} />
          <Route path="/admin/salary-management" element={<UnifiedSalaryManagement />} />
          <Route path="/admin/expense-management" element={<ExpenseDashboard />} />
          <Route path="/admin/expense-requests" element={<ExpenseRequestDashboard />} />
          <Route path="/admin/submit-expense-request" element={<ExpenseRequestForm />} />
          <Route path="/staff-login" element={<AdminLogin />} />
          <Route path="/staff/change-password" element={<StaffForcePasswordChange />} />
          <Route path="/staff-dashboard" element={<StaffDashboard />} />
          <Route path="/teacher-login" element={<AdminLogin />} />
          <Route path="/teacher/change-password" element={<TeacherForcePasswordChange />} />
          <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
          <Route path="/student/midterm" element={<MidtermExamPage />} />
          <Route path="/student/final" element={<FinalExamPage />} />
          <Route path="/student/board" element={<ProgressBoard />} />
          <Route path="/admin/security-management" element={<SecurityManagement />} />
          <Route path="/security/login" element={<AdminLogin />} />
          <Route path="/security/dashboard" element={<SecurityDashboard />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/admin/gallery-management" element={<AdminGalleryManagement />} />
          <Route path="/admin/approval-management" element={<ApprovalManagement />} />
          <Route path="/admin/enrollment-management" element={<EnrollmentManagement />} />
          <Route path="/admin/realtime-overview" element={<RealtimeDashboardOverview />} />
          <Route path="/admin/messaging" element={<AdminMessaging />} />
          <Route path="/admin/ad-management" element={<AdminAdManagement />} />
          <Route path="/admin/email-management" element={<AdminEmailManagement />} />
          <Route path="/admin/tracking" element={<AdminTrackingDashboard />} />

        </Routes>
      </div>

      {/* Footer - hidden on /ad page */}
      {!isAdPage && !isSecurityPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
